import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "../lib/leafletGlobal";
import "leaflet.heat";

export function HeatLayer({ points }) {
  const map = useMap();
  useEffect(() => {
    if (!points.length) return undefined;
    const layer = L.heatLayer(points, {
      radius: 36, blur: 24, maxZoom: 11, minOpacity: 0.5,
      gradient: { 0.2: "#FDE68A", 0.45: "#FB923C", 0.7: "#F5551E", 1: "#B91C1C" },
    }).addTo(map);
    return () => { map.removeLayer(layer); };
  }, [map, points]);
  return null;
}
